import { Box } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useReactFlow } from "reactflow";
import { useTranslation } from "react-i18next";
import { useActiveCanvasId } from "../../contexts/ActiveCanvasIdContext";
import { createNadDebug } from "../../utils/debugLog";

const log = createNadDebug("dw:director-desk:navigation");

export function DirectorDeskToolbarButton({
  project,
  className,
}: {
  project: string;
  className: string;
}) {
  const navigate = useNavigate();
  const canvas = useActiveCanvasId();
  const flow = useReactFlow();
  const { t } = useTranslation("workspace");
  return (
    <button
      type="button"
      className={className}
      title={t("directorDesk.title")}
      aria-label={t("directorDesk.title")}
      data-testid="toolbox-director-desk"
      onClick={() => {
        window.dispatchEvent(new Event("dreamwrite:director-desk-opening"));
        const viewport = flow.getViewport();
        // useYViewport uses this same browser-local key. Save immediately before
        // unmount, including a pan that has not reached its debounce yet.
        localStorage.setItem(
          `dreamwright:workspace-viewport:v1:${project}:${canvas}`,
          JSON.stringify(viewport),
        );
        sessionStorage.setItem(
          `dreamwrite:desk-return:${project}:${canvas}`,
          JSON.stringify({
            selected: flow
              .getNodes()
              .filter((node) => node.selected)
              .map((node) => node.id),
          }),
        );
        log({ event: "stage:open", projectId: project, canvasId: canvas });
        navigate(
          `/project/${encodeURIComponent(project)}/director-desk/${encodeURIComponent(canvas)}`,
        );
      }}
    >
      <Box className="h-4 w-4" />
    </button>
  );
}
